import { Decimal } from 'decimal.js';
import { ElMessage, ElLoadingService } from 'element-plus';
import { messages } from '~/i18n.config';
import { get } from 'lodash-es';
import { getProductResolveLink } from '~/api';
/**
 * 转换rem单位
 
 * @returns {*}
 */

export function toRem(num = 0) {
  return num / getRemRate() + "rem";
}

export function getRemRate() {
  return 10;
}

export function setRemHtml() {
  let setFontSize =
    parseInt((document.documentElement.clientWidth / 375) * getRemRate() * 10) /
    10;
  setFontSize = setFontSize < 10 ? 10 : setFontSize;
  setFontSize = setFontSize > 20 ? 20 : setFontSize;
  document.getElementsByTagName("html")[0].style =
    "font-size:" + setFontSize + "px";
}

/**
 * file转base64
 * @param { * } file 图片文件
 * @return {base64}
 */
export const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function (e) {
      resolve(e.target.result)
      return e.target.result;
    };
  });
};

export function findBaseData(imgUrl, fileName) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.src = imgUrl;
    setTimeout(() => { }, 1000);
    img.onload = () => {
      // console.log("onload," + imgUrl);
      let resData = "data:,";
      let canvas = document.createElement("canvas");
      let canvas2d = canvas.getContext("2d");
      canvas.height = img.height;
      canvas.width = img.width;
      canvas2d.drawImage(img, 0, 0);
      resData = canvas.toDataURL(`image/${fileName.split(".").pop()}`);
      canvas.remove();
      img.remove();
      resolve(resData);
    };
    img.onerror = function () {
      reject("图片加载错误");
      // 在这里处理加载失败的情况
    };
  });
}

export function findBaseDataFn(img, fileName) {
  if (!fileName) fileName = img.split("/").pop();
  return new Promise((resolve, reject) => {
    let timer = null;
    let total = 0;
    findBaseData(img, fileName).then((findData) => {
      if (findData == "data:,") {
        timer = setInterval(() => {
          findBaseData(img, fileName).then((findData) => {
            if (findData != "data:,") {
              clearInterval(timer);
              resolve(findData);
            } else if (total > 10) {
              clearInterval(timer);
              reject("查找不到base64数据");
            }
          });
        }, 500);
      } else {
        resolve(findData);
      }
    });
  });
}

export function compressBase64Image(
  base64Image,
  maxWidth,
  maxHeight,
  maxSizeKB,
  quality = 0.7
) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = base64Image;

    img.onload = function () {
      const width = img.width;
      const height = img.height;

      // 创建 Canvas 对象
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      // 设置压缩比率
      const ratio = Math.min(maxWidth / width, maxHeight / height);
      const newWidth = width * ratio;
      const newHeight = height * ratio;

      canvas.width = newWidth;
      canvas.height = newHeight;

      // 绘制图片到 canvas
      ctx.drawImage(img, 0, 0, newWidth, newHeight);

      // 将 canvas 转换为 Base64 字符串并检查大小
      const compressedBase64 = canvas.toDataURL("image/jpeg", quality);

      // 获取 Base64 字符串的大小（单位为 KB）
      const imageSizeKB = (compressedBase64.length * 3) / 4 / 1024;

      // 如果图片超出了最大文件大小，则继续压缩，直到满足大小限制
      if (imageSizeKB > maxSizeKB) {
        // 逐步减少质量直到图片大小符合要求
        const newQuality = Math.max(0.1, quality - 0.1);
        if (newQuality < 0.1) {
          reject("无法压缩至目标大小");
        } else {
          resolve(
            compressBase64Image(
              base64Image,
              maxWidth,
              maxHeight,
              maxSizeKB,
              newQuality
            )
          );
        }
      } else {
        resolve(compressedBase64); // 返回压缩后的 Base64 图片
      }
    };

    img.onerror = function (error) {
      reject(error);
    };
  });
}



export function $t(key, params = {}) {
  // 获取当前语言环境，默认 'zh-CN'
  let locale = 'zh-CN';
  try {
    if (typeof useNuxtApp === 'function') {
      const { $i18n } = useNuxtApp();
      if ($i18n && $i18n.locale) {
        locale = typeof $i18n.locale === 'function' ? $i18n.locale() : $i18n.locale.value;
      }
    }
  } catch (e) { }

  // 支持嵌套 key，如 'placeholder.pleaseSelected{text}'

  let str = get(messages[locale], key);
  if (typeof str !== 'string') str = key;

  // 替换参数
  if (str && params && typeof params === 'object') {
    Object.keys(params).forEach(k => {
      str = str.replace(new RegExp(`{${k}}`, 'g'), params[k]);
    });
  }
  return str;
}

// 乘法计算
export const multiplication = (value, end) => {
  value = (value === null || value === undefined || value === '') ? 0 : value;
  end = (end === null || end === undefined || end === '') ? 0 : end;
  const vlu = new Decimal(value).mul(new Decimal(end)).toNumber();
  return vlu;
};



export const copyText = (text, hintInfor = "复制,成功!") => {
  let container = document.getElementsByClassName("copyText-container")[0];
  if (!container) {
    const copyInput = document.createElement("textarea");
    copyInput.className = "copyText-container";
    document.body.appendChild(copyInput);
    container = copyInput;
  }
  container.value = "";
  container.value = text;
  container.select(); // 选择对象
  document.execCommand("Copy"); // 执行浏览器复制命令
  if (hintInfor) {
    ElMessage({
      type: "success",
      message: hintInfor,
    });
  }
};

/**
 * 识别 1688 商品详情链接并提取 offerId。
 * @param {string} url 任意输入（完整 URL/只含路径/带 query 的字符串）
 * @returns {string} offerId（未识别到返回空字符串）
 */
export function extract1688OfferId(url = "") {
  const raw = String(url || "").trim();
  if (!raw) return "";

  let text = raw;
  try {
    text = decodeURIComponent(raw);
  } catch (e) { }

  // 轻量判定：不包含这些特征就直接跳过（避免误判）
  const maybe1688 =
    text.includes("1688.com") ||
    text.includes("/offer/") ||
    text.includes("/item/") ||
    text.includes("offerId=") ||
    text.includes("itemId=") ||
    text.includes("ItemId=") ||
    text.includes("id=");

  if (!maybe1688) return "";

  const idPatterns = [
    /offerId=(\d+)/, // offerId= 格式
    /\/offer\/(\d+)\.html/, // /offer/数字.html 格式（包含 detail.1688.com/offer/xxx.html）
  ];

  for (const re of idPatterns) {
    const m = re.exec(text);
    if (m && m[1]) return m[1];
  }

  // 兼容部分业务参数：offerId=123
  const offerIdM = /offerId=(\d+)/.exec(text);
  if (offerIdM && offerIdM[1]) return offerIdM[1];

  return "";
}

/**
 * 识别淘宝商品详情链接并提取 itemId。
 * @param {string} url 任意输入（完整 URL/只含路径/带 query 的字符串）
 * @returns {string} itemId（未识别到返回空字符串）
 */
export function extractTaobaoItemId(url = "") {
  const raw = String(url || "").trim();
  if (!raw) return "";

  let text = raw;
  try {
    text = decodeURIComponent(raw);
  } catch (e) { }

  // 轻量判定：不包含这些特征就直接跳过（避免误判）
  const maybeTaobao =
    text.includes("taobao.com") ||
    text.includes("tmall.com") ||
    text.includes("item.htm") ||
    text.includes("id=");

  if (!maybeTaobao) return "";

  // 优先按标准 URL query 参数读取，避免误匹配 ali_refid、mi_id 等字段。
  const candidateUrls = text.includes("://") ? [text] : [`https://${text}`, text];
  for (const candidate of candidateUrls) {
    try {
      const parsed = new URL(candidate);
      const itemId = parsed.searchParams.get("id");
      if (itemId && /^\d+$/.test(itemId)) return itemId;
    } catch (e) { }
  }

  // 兜底匹配真正的 query 参数 id，而不是其它字段名中包含的 id。
  const idMatch = /(?:\?|&)id=(\d+)(?:&|$)/.exec(text);
  if (idMatch && idMatch[1]) return idMatch[1];

  return "";
}

/**
 * 识别微店商品详情链接并提取 itemID。
 * @param {string} url 任意输入（完整 URL/只含路径/带 query 的字符串）
 * @returns {string} itemID（未识别到返回空字符串）
 */
export function extractWeidianItemId(url = "") {
  const raw = String(url || "").trim();
  if (!raw) return "";

  let text = raw;
  try {
    text = decodeURIComponent(raw);
  } catch (e) { }

  const maybeWeidian =
    text.includes("weidian.com") ||
    text.includes("v.weidian.com") ||
    text.includes("itemID=") ||
    text.includes("itemId=") ||
    text.includes("itemid=");

  if (!maybeWeidian) return "";

  // 优先提取微店标准参数 itemID（不区分大小写）
  const itemIdMatch = /(?:\?|&)(itemid)=([^&#]+)/i.exec(text);
  if (itemIdMatch && itemIdMatch[2]) {
    return itemIdMatch[2];
  }

  return "";
}

function shouldFallbackToKeywordSearch(error) {

  let resErrData= get(error,'response._data')||{}
 
  return resErrData.statusCode==400
    && resErrData.message && resErrData.message.includes("未在输入内容中找到有效链接");
}

function redirectToKeywordSearch(keyword = "") {
  const nextKeyword = String(keyword || "").trim();
  if (!nextKeyword) {
    return;
  }

  if (typeof window !== "undefined" && window.location) {
    window.location.href = `/product/search?keyword=${encodeURIComponent(nextKeyword)}`;
  }
}

export async function extractUrl(url = "") {
  const raw = String(url || "").trim();
  if (!raw) return "";

  try {
    // 优先检查是否为1688链接
    let id1688 = extract1688OfferId(raw);
    if (id1688) {
      if (typeof window !== "undefined" && window.location) {
        window.location.href = `/product?detailId=${id1688}`;
      }
      return "1688";
    }

    // 检查是否为微店链接
    let idWeidian = extractWeidianItemId(raw);
    if (idWeidian) {
      if (typeof window !== "undefined" && window.location) {
        window.location.href = `/wd/goods/${idWeidian}`;
      }
      return "weidian";
    }

    // 检查是否为淘宝链接
    let idTaobao = extractTaobaoItemId(raw);
    if (idTaobao) {
      if (typeof window !== "undefined" && window.location) {
        window.location.href = `/tb/goods/${idTaobao}`;
      }
      return "taobao";
    }

    const loading = ElLoadingService({
      text: $t('messages.parsingProductLink'),
    })
    try {
      // 解析商品链接
      const res = await getProductResolveLink({ input: raw, timeoutMs: 15000 })
      switch (res.platform) {
        case 'weidian':
          window.location.href = `/wd/goods/${res.productId}`
          return
        case 'taobao':
          window.location.href = `/tb/goods/${res.productId}`
          return
        case '1688':
          window.location.href = `/product?detailId=${res.productId}`
          return
        default:
          ElMessage.error($t('messages.productInfoNotRecognized'))
          break
      }
    }
    catch (error) {
      if (shouldFallbackToKeywordSearch(error)) {
        redirectToKeywordSearch(raw);
        return "keyword";
      }
      throw error;
    }
    finally {
      loading.close()
    }
  } catch (e) { }

  return "";
}

if(process.client){
  window.extractUrl = extractUrl;
}
